import React, { forwardRef } from "react";
import styled from "styled-components";
import DateRow from "./DateRow";
import EventCard from "./EventCard";
import AddCardRow from "./AddCardRow";
import Block from "../common/Block";
import { format, parseISO } from "date-fns";
import DateCard from "./DateCard";

const EventBlock = forwardRef(({ date, isToday, sessions, onSessionsUpdate, maxHeight, viewType, weekNum, isAdminView, onWeekClick, isOutsideRange }, ref) => {
    const handleAddActivity = (newSession) => {
        const sessionExists = sessions.some(session => session.id === newSession.id);
        const originalDate = sessionExists ? format(date, 'yyyy-MM-dd') : null;

        if (format(parseISO(newSession.date), 'yyyy-MM-dd') !== originalDate) {
            onSessionsUpdate(
                format(parseISO(newSession.date), 'yyyy-MM-dd'),
                [newSession],
                originalDate
            );
        } else {
            const updatedSessions = sessionExists
                ? sessions.map(session => session.id === newSession.id ? newSession : session)
                : [...sessions, newSession];
            onSessionsUpdate(format(date, 'yyyy-MM-dd'), updatedSessions);
        }
    };

    const groupedSessions = sessions.reduce((acc, session) => {
        const sessionDate = format(parseISO(session.date), 'yyyy-MM-dd');
        if (!acc[sessionDate]) {
            acc[sessionDate] = [];
        }
        acc[sessionDate].push(session);
        return acc;
    }, {});

    // console.log(groupedSessions);

    // If the date is outside the course range, show an empty block
    if (isOutsideRange) {
        return <Block ref={ref} maxHeight={maxHeight} $isEmpty={true} />;
    }

    return (
        <Block ref={ref} maxHeight={maxHeight}>
            {viewType === "day" ? (
                <>
                    <DateRow
                        date={format(date, 'MMM d')}
                        isToday={isToday}
                        sessionsCount={sessions.length}
                        viewType={viewType}
                    />
                    <CardContainer>
                        {sessions.map((session) => (
                            <EventCard
                                key={session.id}
                                session={session}
                                onAddActivity={handleAddActivity}
                                sessionId={session.id}
                                isAdminView={isAdminView}
                            />
                        ))}
                        {!isAdminView && (
                            <AddCardRow
                                date={format(date, 'yyyy-MM-dd')}
                                onAddActivity={handleAddActivity}
                            />
                        )}
                    </CardContainer>
                </>
            ) : (
                <>
                    <DateRow
                        date={`Week ${weekNum}`}
                        isToday={isToday}
                        sessionsCount={Object.keys(groupedSessions).length}
                        viewType={viewType}
                        weekNum={weekNum}
                        onWeekClick={onWeekClick}
                    />
                    <CardContainer>
                        {Object.keys(groupedSessions)
                            .sort((a, b) => new Date(a) - new Date(b))
                            .map((sessionDate) => (
                                <DateCard
                                    key={sessionDate}
                                    date={sessionDate}
                                    sessions={groupedSessions[sessionDate]}
                                />
                            ))}
                    </CardContainer>
                </>
            )}
        </Block>
    );
});

const CardContainer = styled.div`
    margin-top: 5px;
    border-radius: 10px;
    gap: 10px;
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-color: #f3f4f6;
    border-radius: 0.5rem;
    height: 100%;
`;

export default EventBlock;
